import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import Empty from "components/Empty";
import AddStaffButton from "./AddStaffButton";

const EmptyStaffList = ({
  profile,
  officeDetail,
  officeActive,
  officeId,
  location,
  t,
  globalStaffPage,
}) => {
  const canAddStaff =
    profile &&
    profile.profileSetupStep !== "packageExpired" &&
    profile.profileSetupStep !== "subscriptionTerminated" &&
    ((officeDetail && officeActive) || globalStaffPage);

  return (
    <div className="empty-list-block">
      <div className="col-12">
        {canAddStaff ? (
          <Fragment>
            <Empty Message={t("accountOwner.addMoreStaff")} />
            <AddStaffButton
              officeId={officeId}
              location={location}
              variant="button"
              globalStaffPage={globalStaffPage}
            />
          </Fragment>
        ) : (
          <Empty Message={t("noStaffMemberFound")} />
        )}
      </div>
    </div>
  );
};

export default withTranslation()(EmptyStaffList);
